"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@emotion/react");

var _theme = require("../../theme/theme");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Stack = function Stack(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "div" : _ref$as,
      _ref$dir = _ref.dir,
      dir = _ref$dir === void 0 ? "y" : _ref$dir,
      _ref$space = _ref.space,
      space = _ref$space === void 0 ? "1" : _ref$space;

  var spaceValue = _theme.MAP_SPACE[String(space)];

  var marginL = spaceValue;
  var marginT = spaceValue;

  if (dir === 'y') {
    marginL = 0;
  }

  if (dir === 'x') {
    marginT = 0;
  }

  return (0, _react2.jsx)(_react2.ClassNames, null, function (_ref2) {
    var css = _ref2.css,
        cx = _ref2.cx;
    return /*#__PURE__*/_react["default"].createElement(as, {
      className: cx(className, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                box-sizing: border-box;\n                width: 100%;\n                overflow: hidden;\n              "]))))
    }, (0, _react2.jsx)("div", {
      css: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", "\n            ", "\n\n            /* extra specificity over descendants */\n            && > * {\n              margin-top: ", ";\n              margin-left: ", ";\n            }\n          "])), marginT !== 0 && "margin-top: calc(-1 * ".concat(marginT, ");"), marginL !== 0 && "margin-left: calc(-1 * ".concat(marginL, ");"), marginT, marginL)
    }, children));
  });
};

Stack.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  as: _propTypes["default"].string,
  dir: _propTypes["default"].oneOf(_theme.DIRECTION_XY_TYPES),
  space: _propTypes["default"].oneOf(_theme.SPACE_TYPES)
};
var _default = Stack;
exports["default"] = _default;